import { ApiParameter, del, get, post } from "@insite/client-framework/Services/ApiService";
import { CustomReportIssueFormModel } from "@tCooneyBrothers/ApiModels";

const customReportIssueUrl = "api/v2/emailnew";

export async function getCustomerPartNumbers() {
    try {
        const fieldCollection = await get<CustomReportIssueFormModel[]>(`${customReportIssueUrl}`, {})
            .then(response => {
                return response;
            })
            .catch(err => {
                // eslint-disable-next-line no-console
                console.error("Console error", err);
            });
        return fieldCollection;
        // eslint-disable-next-line no-empty
    } catch (error) { }
}

export function addCustomReportIssueFields(parameter: CustomReportIssueFormModel) {
    return post<CustomReportIssueFormModel>(customReportIssueUrl, parameter);
}
